import { Badge, Breadcrumb, Button, Calendar, Col, Collapse, DatePicker, Divider, Drawer, Dropdown, Flex, Form, Input, Layout, Row, Select, Space, Table, Tag, theme, Typography } from 'antd';
import {
    SendOutlined,
    MoreOutlined,
    MessageOutlined,
    UnlockOutlined,
    EyeOutlined,
    LockOutlined,
    EditOutlined
} from '@ant-design/icons';
import React, { useEffect, useRef, useState } from 'react'
import MyResponse from './MyResponse';

const { Search } = Input;
const { Header, Sider, Content } = Layout;
const { Title, Text } = Typography;


const items = [
    {
        key: '1',
        label: (
            <a rel="noopener noreferrer" href="  ">
                Response
            </a>
        ),
        icon: <SendOutlined />,
    },
    {
        key: '2',
        label: (
            <a rel="noopener noreferrer" href="  ">
                View
            </a>
        ),
        icon: <EyeOutlined />,
    },
    {
        key: '3',
        label: (
            <a rel="noopener noreferrer" href="  ">
                Edit
            </a>
        ),
        icon: <EditOutlined />,
    },
    {
        key: '4',
        label: (
            <a rel="noopener noreferrer" href="  ">
                Active
            </a>
        ),
        icon: <UnlockOutlined />,
    },
    {
        key: '5',
        label: (
            <a rel="noopener noreferrer" href="  ">
                Inactive
            </a>
        ),
        icon: <LockOutlined />,
    },
    {
        key: '6',
        label: (
            <a rel="noopener noreferrer" href=" ">
                Chat
            </a>
        ),
        icon: <MessageOutlined />,
    },
];

export default function MyEvents(props) {

    const {
        token: { colorBgContainer, borderRadiusLG },
    } = theme.useToken();


    return (
        <>
            <Badge.Ribbon text={props.status} color={props.status == 'RSVP' ? 'red' : props.status == 'Yes' ? 'green' : props.status == 'No' ? 'geekblue' : 'gold'}>
                <div style={{
                    padding: "16px 12px",
                    background: colorBgContainer,
                    borderRadius: borderRadiusLG,
                    marginBottom: 8
                }}>
                    <Flex justify='space-between' align='center' gap={16}>
                        <Flex justify='start-flex' align='center' gap={16}>
                            <Badge color={props.company == 'default' ? 'green' : 'blue'} />
                                <Flex vertical gap={8}>
                                    <Text style={{width:'500px', wordBreak:'break-word', whiteSpace: 'pre-line', overflowWrap: 'anywhere', marginBottom:'0px'}}>{props.name}</Text>
                                    <Text style={{ fontSize: 12 }}  >{props.date} | {props.time}</Text>
                                </Flex>
                        </Flex>
                        {/* <Dropdown
                            menu={{
                                items
                            }}
                        >
                            <Button type='link' icon={<MoreOutlined />} />
                        </Dropdown> */}
                    </Flex>
                    {<>
                        <Divider />
                        <MyResponse
                            participants={props.participants?.participant}
                            date={props.date}
                            closeDrawer={props.closeDrawer}
                            meetingFullData={props.meetingFullData}
                            actionStep={props.status === 'RSVP' ? 'add' : 'edit'}
                            attendanceStatus={props.status}
                        />
                    </>}
                    {/* {props.status === 'RSVP' ?
                        <>
                            <Divider />
                            <MyResponse 
                                participants={props.participants?.participant}
                                date={props.date}
                                closeDrawer={props.closeDrawer}
                                meetingFullData={props.meetingFullData}
                            />
                        </>
                        // <Collapse accordion size='small' style={{padding:8}}>
                        //     <MyResponse />
                        // </Collapse> 
                        : ""} */}
                </div>
            </Badge.Ribbon>
        </>
    )
}